import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from "../../customComponents/SelectStatus";


export const initObject = {
  id: undefined,
  title: "",
  code: "",
  categoryId: 0,
  categoryTitle: "",
  roomId: 0,
  roomTitle: "",
  isDeleted: false
};


export const columns = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomTitle",
    text: "اتاق",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "categoryId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="seatCategories"
          sname="categoryId"
          label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 3,
        class: "col-lg-4"
      }
    ]
  },
  {
    row: 2,
    list: [
      {
        name: "roomId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/room"
          reduxState="rooms"
          sname="roomId"
          label="اتاق" {...props} />,
        placeholder: "اتاق",
        label: "اتاق",
        rowIdx: 5,
        class: "col-lg-4"
      },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];



export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "categoryId",
    lable: "کاربری",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/category"
        reduxState="seatCategories"
        sname="categoryId"
        {...props} />
  },
  {
    name: "roomId",
    lable: "اتاق",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/room"
        reduxState="rooms"
        sname="roomId"
        {...props} />
  },
  {
    name: "searchText",
    lable: "MODULES.GENERAL.SEARCH",
    type: "text",
    list: [],
  },

];

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, searchText, categoryId, roomId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by categoryId
  filter.categoryId = categoryId !== "" ? +categoryId : 0;
  filter.roomId = roomId !== "" ? +roomId : 0;

  // Filter by all fields
  filter.title = searchText;
  if (searchText) {
    filter.title = searchText;
  }
  newQueryParams.filter = filter;

  let whereClause = "title.contains(@0)"
  const whereClauseParameters = [];
  whereClauseParameters.push(searchText)

  if (filter.categoryId > 0) {
    whereClause = whereClause + " and categoryId=@1"
    whereClauseParameters.push(filter.categoryId)
  }
  else {
    whereClause = whereClause + " and categoryId!=@1"
    whereClauseParameters.push(filter.categoryId)
  }

  if (filter.roomId > 0) {
    whereClause = whereClause + " and roomId=@2"
    whereClauseParameters.push(filter.roomId)
  }
  else {
    whereClause = whereClause + " and roomId!=@2"
    whereClauseParameters.push(filter.roomId)
  }

  if (filter.isDeleted !== undefined) {
    whereClause = whereClause + " and isDeleted=@3"
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  roomId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

